import SocialLoginButtons from '../components/SocialLoginButtons';
import UseDifferentAccountButton from '../components/UseDifferentAccountButton';
import type { OAuthProvider } from '../../../../shared/types/routes/auth/v2';

import styles from '../Login.module.less';

export type OrphanSocialStepProps = {
  /** The email being resumed, shown in the copy. */
  identifier: string;
  providers: OAuthProvider[];
  next?: string;
  onBack: () => void;
};

/**
 * A registered-but-not-onboarded account created via social login (no password). Re-authenticating with the same
 * provider resolves the org-less account and resumes onboarding — the password `CredentialForm` can't help here
 * (there's no password to enter).
 */
const OrphanSocialStep = ({ identifier, providers, next, onBack }: OrphanSocialStepProps) => (
  <div className={styles.card}>
    <h1 className={styles.heading}>Welcome back</h1>
    <p className={styles.placeholder}>Continue with the account you used to sign up with {identifier}.</p>
    <SocialLoginButtons providers={providers} next={next} />
    <UseDifferentAccountButton onClick={onBack} />
  </div>
);

export default OrphanSocialStep;
